export default __webpack_public_path__ + "98abb84908072ded2a45f3da14850f68.svg";